import React, { useState } from "react";
import { useTheme } from "../ThemeContext";
import styles from "./ColorPicker.module.css";

const ColorPicker = ({ onClose }) => {
  const { customHue, setCustomHue, setTheme } = useTheme();
  const [tempHue, setTempHue] = useState(customHue);

  const handleApply = () => {
    setCustomHue(tempHue);
    setTheme("custom");
    onClose();
  };

  const handleCancel = () => {
    setTempHue(customHue);
    onClose();
  };

  // Convert hue to hex color for preview
  const hueToHex = (hue) => {
    const hsl = `hsl(${hue}, 50%, 50%)`;
    return hsl;
  };

  return (
    <div className={styles.colorPickerModal}>
      <div className={styles.colorPickerContent}>
        <h3>Select Custom Color</h3>

        <div className={styles.colorPreview}>
          <div
            className={styles.colorSwatch}
            style={{ backgroundColor: hueToHex(tempHue) }}
          />
        </div>

        <div className={styles.hueSliderContainer}>
          <label htmlFor="hue-slider">Hue: {tempHue}°</label>
          <input
            id="hue-slider"
            type="range"
            min="0"
            max="360"
            value={tempHue}
            onChange={(e) => setTempHue(parseInt(e.target.value))}
            className={styles.hueSlider}
            style={{
              background: `linear-gradient(to right, 
                hsl(0, 100%, 50%), 
                hsl(60, 100%, 50%), 
                hsl(120, 100%, 50%), 
                hsl(180, 100%, 50%), 
                hsl(240, 100%, 50%), 
                hsl(300, 100%, 50%), 
                hsl(360, 100%, 50%))`,
            }}
          />
        </div>

        <div className={styles.colorPickerActions}>
          <button onClick={handleCancel}>Cancel</button>
          <button onClick={handleApply} className={styles.primary}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;
